export default {
  refundDetail: {
    stepState: {
      step1: 'Request Submitted',
      step2: 'Pending Review',
      step3: 'Rejected',
      step4: 'Cancelled',
      step5: 'Completed'
    },
    fwdjd: {
      msg1: 'Service Ticket Progress',
      msg2: 'Ticket No.:',
      msg3: 'Request Date:',  // Fixed duplicate msg4 key
      msg4: 'Status:',
      msg5: 'Cancel Request',
      msg6: 'Contact Merchant',
      msg7: 'Processed By:',
      msg8: 'Processed On:',
    },
    fwdxx: {
      fwd1: 'Service Ticket:',
      fwd2: 'Order Information:',
      fwd3: 'Order No.:',
      fwd4: 'Payment Method:',
      fwd5: 'Order Amount:',
      fwd6: 'Amount Paid:',
      fwd7: 'Delivery Method:',
      fwd8: 'Merchant Delivery:',
      fwd9: 'Customer Pickup:',
      fwd10: 'Payment Type:'
    },
    peisong: {
      psInfo1: 'Delivery Information',
      psInfo2: 'Recipient:',
      psInfo3: 'Mobile:',
      psInfo4: 'Address:',
      psInfo5: 'Pickup Point:',
      psInfo6: 'Pickup Address:',
      psInfo7: 'Pickup Contact:',
      psInfo8: 'Contact:'
    },
    tuikuan: {
      tkInfo1: 'Refund Details',
      tkInfo2: 'Refund Method:',
      tkInfo3: 'Original Payment Method',
      tkInfo4: 'Product Condition:',
      tkInfo5: 'Refund Reason:',
      tkInfo6: 'Claim Amount:',
      tkInfo7: 'Actual Refund:',
      tkInfo8: 'Refund Status:',
      tkInfo9: 'Remarks:'
    },
    qingdan: {
      qdInfo1: 'Item List',  // Fixed duplicate keys
      qdInfo2: 'Product',
      qdInfo3: 'Specs:',
      qdInfo4: 'Qty',
      qdInfo5: 'Unit Price',
      qdInfo6: 'Subtotal',
      qdInfo7: 'Total Items:',
      qdInfo8: 'Product Refund:',
      qdInfo9: 'Shipping Refund:',
      qdInfo10: 'Total Claim:'
    },
    confirmState: {
      confirm1: 'Notification',
      confirm2: 'Confirm',
      confirm3: 'Cancel',
      confirm4: 'Cancelled',
      confirm5: 'Cancel this service ticket?'
    }
  }
}